<template>
    <contacts-find
        :params="{
            contact: $route.params.contact
        }"
        :include="[
            'address',
            'job_sheets(include:contacts,maintenance)',
            'telephone_number'
        ]"
        v-slot="{
            sid,
            data: contact,
            error,
            is_loading,
            has_loaded,
            find
        }"
    >
        <div v-if="!has_loaded || error">
            <base-loading
                :error="error"
                :retry="find"
                class="py-6"
            />

            <error-modal
                v-if="error"
                :error="error"
            />
        </div>

        <div v-else>
            <base-hint
                v-if="false"
                name="landlords-contacts-show"
            >
                <template slot="heading">
                    Viewing a contact
                </template>

                <p>
                    ...
                </p>
            </base-hint>

            <details-card
                class="mb-6 id-details-card"
                :is-open="true"
            >
                <template slot="header">
                    <div class="flex-grow mr-3 overflow-hidden">
                        <h1 class="text-lg font-normal truncate">
                            {{ contact.name }}
                        </h1>
                    </div>

                    <div
                        v-if="is_loading"
                        class="w-6 h-6 mr-3"
                    >
                        <base-svg
                            name="icon-loading"
                            class="w-full h-full"
                        />
                    </div>

                    <edit-dropdown
                        :contact="contact"
                        class="flex-none"
                        @success="find"
                    />
                </template>
                <template slot="body">
                    <grid-layout>
                        <grid-layout-item class="mb-3 sm:w-1/2 lg:w-1/3">
                            <div class="text-xs text-label">Email</div>
                            <div class="text-sm">
                                <template v-if="contact.email">
                                    <a-mailto
                                        :email="contact.email"
                                        class="text-blue"
                                    />

                                    <base-tooltip
                                        v-if="!contact.email_is_valid"
                                        class="inline-block"
                                    >
                                        <base-svg
                                            slot="trigger"
                                            name="icon-important-circle"
                                            class="inline-block w-4 h-4 -mt-1"
                                        />

                                        <template slot="tooltip">
                                            This doesn't appear to be a valid email.
                                        </template>
                                    </base-tooltip>
                                </template>

                                <base-na v-else />
                            </div>
                        </grid-layout-item>

                        <grid-layout-item class="mb-3 sm:w-1/2 lg:w-1/3">
                            <div class="text-xs text-label">Telephone</div>
                            <div class="text-sm">
                                <template v-if="contact.telephone">
                                    <a-tel
                                        :telephone="contact.telephone"
                                        class="text-blue"
                                    />

                                    <base-tooltip
                                        v-if="contact.telephone_number && !contact.telephone_number.is_valid"
                                        class="inline-block"
                                    >
                                        <base-svg
                                            slot="trigger"
                                            name="icon-important-circle"
                                            class="inline-block w-4 h-4 -mt-1"
                                        />

                                        <template slot="tooltip">
                                            This doesn't appear to be a valid number.
                                        </template>
                                    </base-tooltip>
                                </template>

                                <base-na v-else />
                            </div>
                        </grid-layout-item>

                        <grid-layout-item class="mb-3">
                            <div class="text-xs text-label">Address</div>
                            <div class="text-sm">
                                <base-address
                                    v-if="contact.address"
                                    :address="contact.address"
                                    :is-inline="true"
                                />

                                <base-na v-else />
                            </div>
                        </grid-layout-item>

                        <grid-layout-item class="mb-3 sm:w-1/2 lg:w-1/3">
                            <div class="text-xs text-label">Job Title</div>
                            <div class="text-sm">
                                <template v-if="contact.job_title">
                                    {{ contact.job_title }}
                                </template>

                                <base-na v-else />
                            </div>
                        </grid-layout-item>

                        <grid-layout-item class="mb-3 sm:w-1/2 lg:w-1/3">
                            <div class="text-xs text-label">Company</div>
                            <div class="text-sm">
                                <template v-if="contact.company">
                                    {{ contact.company }}
                                </template>

                                <base-na v-else />
                            </div>
                        </grid-layout-item>
                    </grid-layout>
                </template>
            </details-card>

            <job-sheets-card
                :data="contact.job_sheets.data"
                :meta="{}"
                :can-new="true"
                :new-to="{
                    name: $router.fix('dashboard.*.job-sheets.create'),
                    query: {
                        contact: contact.uuid
                    }
                }"
                class="mb-6"
            >
                <template v-slot:primary="{ job_sheet }">
                    <truncate-hack>
                        {{ job_sheet.maintenance.title }}
                    </truncate-hack>
                </template>
            </job-sheets-card>
        </div>
    </contacts-find>
</template>

<script>
    import ContactsFind from '../../../../components/contacts-find'
    import DetailsCard from '../../../../components/details-card'
    import EditDropdown from './show/edit-dropdown'
    import JobSheetsCard from '../../../../components/job-sheets-card'

    export default {
        components: {
            ContactsFind,
            DetailsCard,
            EditDropdown,
            JobSheetsCard
        }
    }
</script>
